<template>
    <a-form
        layout="horizontal"
    >   
        
        <a-form-item
            v-bind="formItemLayout"
        >
            <h3
                slot="label"
            >
                {{ label }}
            </h3>
            <a-range-picker
                v-model="momentDateRange"
            >

            </a-range-picker>
        </a-form-item>    
    </a-form>
</template>

<script>
import moment from 'moment'

export default {
    name: 'SearchDateRange',

    props: {
        dateRange: Array,
        label: String
    },
    model: {
        prop: 'dateRange',
        event: 'dateRangeChange'
    },
    data() {
        return {
            formItemLayout: {
                labelCol: { span: 24 },
                wrapperCol: { span: 24 }
            },
        }
    },

    computed: {
        momentDateRange: {
            get() {
                if (this.dateRange.length) {
                    return [moment(this.dateRange[0]), moment(this.dateRange[1])]
                } else {
                    return []
                }
            },
            set(val) {
                console.log('SETVAL', val); 
                if (val.length) {
                    const values = [val[0].format('YYYY-MM-DD'), val[1].format('YYYY-MM-DD')]
                    console.log('DATERANGE', values);
                    this.$emit('dateRangeChange', values);
                }
                else {
                    this.$emit('dateRangeChange', val);
                }
                
            }
        }
    },

    methods: {
        rangeChange(value) {
            
            
        },
        moment
    }
}
</script>

<style lang="scss" scoped>

</style>